import React from 'react'
import { useAppSelector } from 'reduxTyped'

import { BuilderIdContext } from 'common/builder/components/builder/BuilderIdProvider'
import { getFlowPersonalizationFields } from 'common/builder/selectors/builder/fieldsSelectors'
import { Field } from 'common/fields/entities/field'

export type FieldsSelector = (state: RootState, builderId: string) => Field[]

export const useFlowFields = (
  fieldsSelector: FieldsSelector = getFlowPersonalizationFields,
): Field[] => {
  const builderId = React.useContext(BuilderIdContext)?.builderId
  const fields = useAppSelector((state) => fieldsSelector(state, builderId))
  return fields
}
